module.exports = __webpack_public_path__ + "static/media/Países top diversidad lingüística.00af104e.png";